/**
 * Sincroniza el tachado de variantes en ambas direcciones (Stiletto theme).
 *
 * El tema nativo solo tacha Color en función de la Talla seleccionada.
 * Este script añade el cruce inverso (Talla en función del Color) y,
 * de paso, generaliza el cálculo a cualquier número de opciones
 * (por si en el futuro se añade option3), reutilizando el mismo
 * [data-variant-json] y las mismas clases que ya pinta el tema.
 *
 * No modifica theme.min.js: es un archivo aparte, a prueba de
 * actualizaciones del tema.
 */
(function () {
  var DISABLED_CLASS = 'disabled';
  var SELECT_WRAPPER_CLASS = 'select-wrapper'; // el tema no tacha opciones en modo <select> plano
  var BOUND_ATTR = 'data-symmetric-availability-bound';

  function parseVariants(wrapper) {
    var jsonEl = wrapper.querySelector('[data-variant-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getOptionKeys(variants) {
    var keys = [];
    ['option1', 'option2', 'option3'].forEach(function (key) {
      if (variants.some(function (v) { return v[key] !== null && v[key] !== undefined; })) {
        keys.push(key);
      }
    });
    return keys;
  }

  function recompute(wrapper, variants, selects, keys) {
    var selected = {};
    keys.forEach(function (key) {
      var select = selects[key];
      if (select) selected[key] = select.value;
    });

    keys.forEach(function (key) {
      var wrap = wrapper.querySelector('.dynamic-variant-input-wrap[data-index="' + key + '"]');
      if (!wrap || wrap.classList.contains(SELECT_WRAPPER_CLASS)) return;

      var buttons = wrap.querySelectorAll('.dynamic-variant-button');
      var soldOutByValue = {};
      buttons.forEach(function (btn) { soldOutByValue[btn.dataset.optionValue] = true; });

      variants.forEach(function (variant) {
        var value = variant[key];
        if (value === null || value === undefined) return;
        if (!(value in soldOutByValue)) return;
        if (!variant.available) return;

        // ¿Esta variante coincide con lo seleccionado en las DEMÁS opciones?
        var matchesOthers = keys.every(function (otherKey) {
          if (otherKey === key) return true;
          return selected[otherKey] === undefined || variant[otherKey] === selected[otherKey];
        });

        if (matchesOthers) soldOutByValue[value] = false;
      });

      buttons.forEach(function (btn) {
        var soldOut = soldOutByValue[btn.dataset.optionValue];
        btn.classList.toggle(DISABLED_CLASS, !!soldOut);
      });
    });
  }

  function initWrapper(wrapper) {
    if (wrapper.getAttribute(BOUND_ATTR) === 'true') return;

    var variants = parseVariants(wrapper);
    if (!variants || !variants.length) return;

    var keys = getOptionKeys(variants);
    if (keys.length < 2) return; // solo 1 opción: nada que cruzar

    var selects = {};
    keys.forEach(function (key) {
      selects[key] = wrapper.querySelector('.dynamic-variant-input[data-index="' + key + '"]');
    });
    if (Object.keys(selects).some(function (k) { return !selects[k]; })) return;

    function onAnyChange() {
      // setTimeout(0): se ejecuta DESPUÉS del listener nativo del tema,
      // así que nuestro resultado es el que queda pintado en pantalla.
      setTimeout(function () { recompute(wrapper, variants, selects, keys); }, 0);
    }

    keys.forEach(function (key) {
      selects[key].addEventListener('change', onAnyChange);
    });

    wrapper.setAttribute(BOUND_ATTR, 'true');
    recompute(wrapper, variants, selects, keys); // estado inicial correcto también
  }

  function scan(root) {
    root.querySelectorAll('.product__variants-wrapper').forEach(initWrapper);
  }

  function start() {
    scan(document);

    // Cubre formularios de producto inyectados por AJAX (quick view, quick add, etc.)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.product__variants-wrapper')) initWrapper(node);
          if (node.querySelectorAll) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();